import React from 'react'
import Banner from '../components/Banner'
import AllProducts from './AllProducts'
function Home() {

    return (
        <>
            <Banner />
            <AllProducts />
        </ >
    )
}

export default Home